export default __webpack_public_path__ + "static/media/add_tags.72bd77ca.png";